import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../Styles/insights/InsightsAziro.css";

export default function InsightsAziro() {
    const navigate = useNavigate();
    return (
        <div className="insights-aziro-outer">
            <div className="insights-aziro-header-section">
                <h1 className="insights-aziro-title">
                    Aziro: Where innovation drives a people-first workplace.
                </h1>
            </div>
            <div className="insights-aziro-mainrow">
                <div className="insights-aziro-mainimg-container">
                    <img src="/assets/insights/aziro.jpg" alt="Aziro" className="insights-aziro-mainimg" />
                    <div className="insights-aziro-badge">
                        <img src="/assets/Badge_TM.png" alt="Certified Badge" className="insights-aziro-badge-imgmain" />
                    </div>
                </div>
                <div className="insights-aziro-sidecard">
                    <div className="insights-aziro-sidecard-badge">
                        <img src="/assets/Badge_TM.png" alt="Certified Badge" className="insights-aziro-badge-img" />
                    </div>
                    <div className="insights-aziro-sidecard-bg">
                        <img src="/assets/insights/aziro_2.jpg" alt="Aziro Team" />
                    </div>
                    <div className="insights-aziro-sidecard-content">
                        <h3>Earn the Outstanding<br /><span>Workplaces Certification</span></h3>
                        <ul>
                            <li>Attract Top Talent</li>
                            <li>Boost Employee Engagement</li>
                            <li>Drive Culture-Led Growth</li>
                        </ul>
                        <button className="insights-aziro-sidecard-btn" onClick={() => navigate('/nominate')}>Get Certificate</button>
                    </div>
                </div>
            </div>
            <div className="insights-aziro-share">
                <span>Share :</span>
                <img
                    src="/icons/insightstwitter.png"
                    alt="Twitter"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
                <img
                    src="/icons/insightslinkedin.png"
                    alt="LinkedIn"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
                <img
                    src="/icons/insightsfacebook.png"
                    alt="Facebook"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
                <img
                    src="/icons/insightswhatsapp.png"
                    alt="WhatsApp"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://wa.me/?text=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
            </div>
            <div className="insights-aziro-content-section">
                <h2 className="insights-aziro-content-title">At Outstanding Workplaces, we believe exceptional workplaces thrive where innovation, leadership, and employee experience intersect.<br/>Through our certification journey, we partner with organizations to uncover and celebrate the practices that define their culture and shape how employees experience work every day.</h2>
                <ul>
                    <li>Aziro (formerly MSys Technologies) exemplifies this approach. As an AI-native product engineering company, Aziro drives innovation-led technology transformation for Fortune 500 and Global 2000 enterprises, as well as ISVs, combining cutting-edge solutions with a people-focused culture.</li>
                </ul>
                <h3>Prioritize Employee Wellbeing</h3>
                <ul>
                    <li>Great workplaces recognize that happy, healthy employees are more productive. Aziro emphasizes holistic wellbeing programs, from mental health support to flexible work arrangements, creating a culture where people thrive.</li>
                </ul>
                <h3>Foster Transparent Communication</h3>
                <ul>
                    <li>Open, honest communication builds trust. Outstanding Workplaces encourages organizations to implement clear feedback channels, town halls, and cross-team updates to keep everyone aligned.</li>
                </ul>
                <h3>Encourage Continuous Learning</h3>
                <ul>
                    <li>Upskilling drives engagement and innovation. Aziro invests in employee learning, certifications, and internal knowledge sharing to keep teams future-ready.</li>
                </ul>
                <h3>Promote Inclusive Leadership</h3>
                <ul>
                    <li>Leaders shape culture. Effective leaders at Aziro and other certified organizations actively practice inclusion, mentorship, and recognition, empowering all employees to contribute meaningfully.</li>
                </ul>
                <h3>Recognize and Reward Contributions</h3>
                <ul>
                    <li>Acknowledging effort motivates employees. Implement structured recognition programs and celebrate successes big and small, reinforcing positive behaviors.</li>
                </ul>
                <h3>Embrace Innovation and Experimentation</h3>
                <ul>
                    <li>Aziro thrives on innovation-led tech transformation. Organizations that encourage creative problem-solving, experimentation, and safe failure cultivate high-performing, agile cultures.</li>
                </ul>
                <h3>Define Clear Goals and Expectations</h3>
                <ul>
                    <li>Clarity reduces confusion and enhances accountability. Establish transparent objectives, key results (OKRs), and performance metrics that align individual contributions with organizational goals.</li>
                </ul>
                <h3>Enable Work-Life Flexibility</h3>
                <ul>
                    <li>Flexible work models improve satisfaction and retention. Certified workplaces understand that balance leads to happier employees and better business outcomes.</li>
                </ul>
                <h3>Measure and Improve Employee Experience</h3>
                <ul>
                    <li>Data-driven insights guide culture improvements. Conduct regular engagement surveys, pulse checks, and feedback loops to continuously enhance the employee experience.</li>
                </ul>
                <h3>Build a Purpose-Driven Culture</h3>
                <ul>
                    <li>Employees engage deeply when work aligns with purpose. Aziro and other top workplaces integrate mission-driven initiatives, sustainability, and social responsibility into everyday work.</li>
                </ul>
            </div>
        </div>
    );
}
